module.exports = __webpack_public_path__ + "img/Material1.a34dc976.gif";